import { Field } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'
import DateField from '../DateField'

const propTypes = {
  /**
   * id of the field. The id passed is also bound to the field's name
   */
  id: PropTypes.string.isRequired,
}

/**
 * Connects the DateField with Formik
 */
function FormikDateField(props) {
  const { id } = props

  return (
    <Field name={id}>
      {({ field, meta }) => (
        <DateField
          {...props}
          id={id}
          name={id}
          onChange={field.onChange}
          onBlur={field.onBlur}
          value={field.value ?? ''}
          errors={meta.touched && meta.error ? [meta.error] : []}
        />
      )}
    </Field>
  )
}

FormikDateField.propTypes = propTypes

export default FormikDateField
